export const justifyContent = {
  patterns: {
    '*': '{{value}}',
  },
  properties: 'justify-content',
};

export const justifyItems = {
  patterns: {
    '*': '{{value}}',
  },
  properties: 'justify-items',
};

export const justifySelf = {
  patterns: {
    '*': '{{value}}',
  },
  properties: 'justify-self',
};
